import Tippy from '@tippyjs/react';
import ReactMarkdown from 'react-markdown';
import { RedirectExternal } from '@/components/Dialogs/Redirect';
import userMentions from '@/components/markdown/rehype/userMentions';
import UserMention from '@/components/markdown/view/UserMention';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { darcula } from 'react-syntax-highlighter/dist/cjs/styles/prism';
import langMap from '@/components/markdown/langMap';
//@ts-ignore
import Twemoji from 'react-twemoji';
import emojisRehype from '@/components/markdown/rehype/emojis';
import EmojiMarkdown from '@/components/markdown/view/Emoji';
import toast from 'react-hot-toast';


export default function Markdown({ children, message}: { children: any, message?: any }) {
    return (
        <ReactMarkdown
            className="text-base break-all whitespace-pre-wrap"
            rehypePlugins={[userMentions, emojisRehype]}
            components={{
                // @ts-ignore
                emoji: ({ node, ...props }) => <EmojiMarkdown {...props} message={message} />,
                // @ts-ignore
                mention: ({ node, ...props }) => <UserMention {...props} />,
                p: ({ node, ...props }) => <p {...props} className="text-gray-300 " />,
                a: ({ node, ...props }) => {
                    let { href, children, ...rest } = props;
                    if (href) {
                        href = href.split("@").pop();
                        if(!href?.startsWith("http")) href = `https://${href}`;                        
                        return (
                            <RedirectExternal link={href}>
                                <a
                                    {...rest}
                                    className={`hover:underline z-10 hover:cursor-pointer ${message?.state == "sending" ? "" : "text-blue-400"} ${message.state == "failed" ? "text-red-400" : ""}`}
                                >
                                    {children}
                                </a>
                            </RedirectExternal>
                        );
                    }
                    return <span>{children}</span>;
                },
                h1: ({ node, ...props }) => <h1 {...props} className="text-gray-300 font-semibold text-3xl flex gap-1" />,
                h2: ({ node, ...props }) => <h2 {...props} className="text-gray-300 font-semibold text-2xl flex gap-1" />,
                h3: ({ node, ...props }) => <h3 {...props} className="text-gray-300 font-semibold text-xl flex gap-1" />,
                h4: ({ node, ...props }) => <h4 {...props} className="text-gray-300 font-semibold text-lg flex gap-1" />,
                h5: ({ node, ...props }) => <h5 {...props} className="text-gray-300 font-semibold text-base flex gap-1" />,
                h6: ({ node, ...props }) => <h6 {...props} className="text-gray-300 font-semibold text-sm flex gap-1" />,
                code: ({ node, className, children, inline, ...props }: any) => {
                    const match = /language-(\w+)/.exec(className || '');
                    return match ? (
                        <>
                            <div className="relative">
                                <Tippy content="Copy to Clipboard" className="absolute -top-2 right-0 bg-brand-green p-1 hover:underline rounded-tl-lg rounded-br-lg cursor-pointer">
                                    <div className='absolute  -top-2 left-0 bg-brand-green p-1 hover:underline rounded-tl-lg rounded-br-lg cursor-pointer'>
                                        <p className='text-xs text-white' onClick={() => {
                                            navigator.clipboard.writeText(children)
                                            toast.success("Copied to clipboard")
                                        }}>
                                            {langMap.get(match ? match[1] : "Text") || "Text"}
                                        </p>
                                    </div>
                                </Tippy>
                                <div className='max-w-[50rem]'>
                                    <SyntaxHighlighter
                                        language={match ? match[1] : undefined}
                                        style={darcula}
                                        {...props}
                                        className="rounded-lg p-2 overflow-x-auto break-words w-full"
                                    >

                                        {String(children || "").replace(/\n$/, '')}
                                    </SyntaxHighlighter>
                                </div>
                            </div>
                        </>
                    ) : (
                        <code {...props} className="bg-gray-800 px-1 py-0.5 rounded">
                            {children}
                        </code>
                    );
                },
                blockquote: ({ node, ...props }) => <blockquote {...props} className="border-l-4 border-gray-600 px-2 flex gap-1" />,
                ul: ({ node, ...props }) => <ul {...props} className="list-disc list-inside flex gap-1" />,
                ol: ({ node, ...props }) => <ol {...props} className="list-decimal list-inside flex gap-1" />,
                img: ({ node, ...props }) => <span {...props} className="text-gray-300">
                    {props.alt}
                </span>,
            }}
        >
            {children}
        </ReactMarkdown>

    )
}